import { updateCollectionPageLinksByRouterConfig } from '@wix/ambassador-data-collection-page-links-v1-collection-page-links/http'
import type { PageData } from '@wix/editor-platform-sdk-types'
import type { HttpClient } from '@wix/http-client'
import type {
  DynamicPageRouterData,
  EditorSDK,
  Logger,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'
import { keyBy, mapValues } from 'lodash'
import { runWithRetry } from '../../infra/runWithRetry'
import { findPageIdByPageRole } from './router-config'

const hasRouteWithPageLinkId = (router: DynamicPageRouterData) =>
  Object.values(router.config.patterns).some(
    ({ config }) => !!config.pageLinkId,
  )

const enrichRoutesWithPageLinkDisplayName = (
  router: DynamicPageRouterData,
  pagesById: Record<string, PageData>,
) => ({
  ...router,
  config: {
    ...router.config,
    patterns: mapValues(router.config.patterns, patternDefinition => {
      const pageId = findPageIdByPageRole(router, patternDefinition.pageRole)!

      return {
        ...patternDefinition,
        config: {
          ...patternDefinition.config,
          pageLinkDisplayName: pagesById[pageId].title,
        },
      }
    }),
  },
})

const TRY_COUNT = 2

export const syncRouters = async ({
  editorSdkProxy,
  httpClient,
  logger,
}: {
  editorSdkProxy: EditorSDK
  httpClient: HttpClient
  logger: Logger
}) => {
  try {
    const [routers, pages] = await Promise.all([
      editorSdkProxy.routers.getAll<RouterConfig>(),
      editorSdkProxy.pages.getApplicationPages({
        includeUnmanaged: false,
      }),
    ])

    const pagesById = keyBy(pages, 'id')

    const routersWithPageLinkId = routers
      .filter(hasRouteWithPageLinkId)
      .map(router => enrichRoutesWithPageLinkDisplayName(router, pagesById))

    await runWithRetry(
      () =>
        httpClient.request(
          updateCollectionPageLinksByRouterConfig({
            routers: routersWithPageLinkId,
          }),
        ),
      TRY_COUNT,
    )
  } catch (err) {
    logger.error(
      new Error('Failed to sync routers', {
        cause: err,
      }),
    )

    throw err
  }
}
